import type { RemoteExtensionsConfiguration } from 'src/gql/graphql';

const LIVE_PREVIEW_SCOPE = 'customer_themes';

/** Reads `manifest_url` and `theme` query params to build a live preview config for module federation. */
export function getLivePreviewConfig(): RemoteExtensionsConfiguration | null {
  if (typeof window === 'undefined') return null;

  const params = new URLSearchParams(window.location.search);
  const manifestUrl = params.get('manifest_url');
  const theme = params.get('theme');

  if (!manifestUrl || !theme) return null;

  // Validate the URL is well-formed and uses http(s) so we don't hand a
  // javascript:/data: URL (or similar) to Module Federation. Any http(s) host
  // is allowed — localhost for local dev, or a hosted/tunneled/staged manifest
  // URL for sharing a preview build with teammates.
  try {
    const url = new URL(manifestUrl);
    if (!['http:', 'https:'].includes(url.protocol)) return null;
  } catch {
    return null;
  }

  return {
    manifestUrl,
    modulePath: `themes/${theme}`,
    scope: LIVE_PREVIEW_SCOPE,
  };
}
